<template>
    <sa-page-layout slot="table-body" :btnConfigurazioniVisible="btnConfigurazioniVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :showModalLoading="showModalLoading" :linkConfigurazioni="linkConfigurazioni">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovoTipoArticolo">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">ARTICOLI TIPO</label>
                        <b-form-input v-model="dadefinire" type="search" id="nome" placeholder="dadefinire"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">ARTICOLI TIPO</label>
                        <b-form-input v-model="dadefinire" type="search" placeholder="dadefinire"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <!-- <configurazioni-magazzino-articoli-list-component ref="cmpConfigurazioniMagazzinoArticoliList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" /> -->
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
// import ConfigurazioniMagazzinoArticoliListComponent from "../components/ConfigurazioniMagazzinoArticoliListComponent.vue";
export default {
    components: { SaPageLayout },

    data() {
        return {
            dadefinire: null,
            filtroTipoArticolo: {
                nome: null,
                codicePrestazione: null,
            },
            btnNewVisible: false,
            btnConfigurazioniVisible: true,
            linkConfigurazioni: "/configurazionemagazzino",
            pathResource: "",
            showModalLoading: false,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoArticoliList.loadData();
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroTipoArticolo"] = JSON.stringify(me.filtroTipoArticolo);
            me.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onReset() {
            let me = this;
            me.filtroTipoArticolo = { dadefinire: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroTipoArticolo"] = JSON.stringify(me.filtroTipoArticolo);
            me.loadData();
        },
        onClickNuovoTipoArticolo() {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoArticoliList.onNuovoTipoArticolo();
        },
        onUpdateFilter(filterData) {
            let me = this;
            me.filtroTipoArticolo = filterData;
        },
    },
};
</script>
